import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

const NAV = [
  { label: "About", href: "#about" },
  { label: "Team", href: "#team" },
  { label: "Robots", href: "#robots" },
  { label: "Gallery", href: "#gallery" },
  { label: "Outreach", href: "#outreach" },
  { label: "Sponsors", href: "#sponsors" },
  { label: "Contact", href: "#contact" },
];

export default function Header() {
  const { settings } = useSettings();
  const [first, ...rest] = (settings.team_name || "Voltage Vipers").split(" ");
  const second = rest.join(" ") || "";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-voltage-bg/70 backdrop-blur-xl border-b border-voltage-blue/40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-4 flex items-center justify-between gap-6">
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center gap-3 group"
        >
          <img
            src={settings.logo_url}
            alt={settings.team_name}
            className="h-10 w-10 object-contain animate-pulse-glow"
          />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-display font-black text-base tracking-[0.18em] text-white uppercase">
              {first}
            </span>
            {second && (
              <span className="font-display font-black text-base tracking-[0.18em] text-voltage-yellow uppercase">
                {second}
              </span>
            )}
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="font-display text-xs font-bold uppercase tracking-[0.25em] text-white/80 hover:text-voltage-yellow transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-voltage-yellow group-hover:w-full transition-all" />
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-cta-sponsor"
          className="btn-primary clip-bolt hidden md:inline-flex"
        >
          <Zap className="w-4 h-4" /> Sponsor Us
        </a>
      </div>
    </header>
  );
}
